<template>
  <el-dialog class="rc-dialog" :title="title" :visible.sync="isShow" :close-on-click-modal="false" @close="handleClose"
    width="880px">
    <el-form ref="lForm" :model="lObject" size="small" label-width="100px" class="form">
      <el-row>
        <el-col>
          <el-form-item label="适用组织：" prop="deptId" :rules="[{ required: true, message: '请选择适用组织' }]">
            <el-select v-model="lObject.deptId" placeholder="请选择适用组织" style="width:100%;" :disabled="isEdit">
              <el-option v-for="(item, i) in deptList" :key="i" :label="item.deptName" :value="item.uuid"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="资源类型：" prop="resourceType" :rules="[{ required: true, message: '请选择资源类型' }]">
            <el-select v-model="lObject.resourceType" placeholder="请选择资源类型" style="width:100%;" :disabled="isEdit">
              <el-option v-for="(item, i) in resourceTypeList" :key="i" :label="item.paramValue"
                :value="parseInt(item.paramKey)"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="时长规则：" required>
            <div class="rules_row" v-for="(item, i) in hourRules" :key="i">
              <el-input-number class="time" v-model="item.duration" :min="0" :precision="0"
                @change="onNumberChange($event, item, i)" size="mini"></el-input-number>
              分钟(不含)以上，可获得
              <el-input-number class="credit" v-model="item.credit" :min="0" :precision="2"
                size="mini" :step="0.5"></el-input-number>
              学时
              <el-dropdown class="add-m" split-button type="primary" @click="addRule('1', item, i)"
                @command="addRule($event, item, i)" size="mini">
                新增
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="0">从上方新增一条</el-dropdown-item>
                  <el-dropdown-item command="1">从下方新增一条</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-popconfirm v-if="hourRules.length > 1" title="确认删除该条规则吗？" @confirm="deleteRule(item, i)" size="mini">
                <butn slot="reference" title="删除" size="mini"></butn>
              </el-popconfirm>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeFrom()" btntype title="取消"></butn>
      <butn btntype="primary" @click.native="submitForm()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { topDeptList } from "@/api/dept";
import { getSysParamByTypes } from "@/api/sysParam";
import {
  creditRuleInfoNew,
  creditRuleSaveNew,
  creditRuleUpdateNew
} from "@/api/creditRule";

export default {
  name: "curd",
  components: { butn },
  data() {
    return {
      resourceTypeList: [],
      deptList: [],
      isShow: false,
      title: "",
      lObject: {
        deptId: "",
        resourceType: "",
      },
      hourRules: [{
        duration: 0,
        credit: 0,
      }],
      isEdit: false,
    };
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.resourceTypeList = res.data["CREDIT_RESOURCE_TYPE"];
        // this.unitTypeList = res.data["CREDIT_RULE_UNIT"];
      });
    },
    closeFrom() {
      this.isShow = false;
      this.$refs["lForm"].resetFields();
    },
    handleClose() {
      this.$refs["lForm"].resetFields();
      this.lObject = {
        deptId: "",
        resourceType: "",
      };
      this.hourRules = this.$options.data().hourRules;
    },
    showFrom(msg) {
      this.isShow = true;
      this.title = msg;
    },
    info(params) {
      creditRuleInfoNew(params).then(res => {
        if (res && res.code === 0) {
          const {data = {}} = res;
          this.lObject = res.data;
          this.lObject = {
            deptId: data.deptId,
            resourceType: data.resourceType,
          };
          this.hourRules = data.ruleList || this.$options.data().hourRules;
        }
      });
    },
    submitForm() {
      this.$refs["lForm"].validate(valid => {
        if (valid) {
          if (this.checkArray()) {
            let params = {
              ...this.lObject,
              ruleList: this.hourRules
            }
            let api = creditRuleSaveNew;
            if (this.isEdit) {
              api = creditRuleUpdateNew;
            }
            api(params).then(res => {
              if (!res || res.code !== 0) return;
              this.$emit("refresh");
              this.closeFrom();
            });
          }

        }
      });
    },
    addCr() {
      this.showFrom("新增");
      this.isEdit = false;
    },
    updateCr(params) {
      this.info(params);
      this.showFrom("编辑");
      this.isEdit = true;
    },
    onNumberChange(value, item, i) {
      if (value === '' || value === null || value === undefined) {
        item.duration = '0';
      }
    },

    addRule(flag, item, i) {
      let emptyItem = {
        duration: 0,
        credit: 0,
      }
      if (flag == 1) {
        this.hourRules.splice(i + 1, 0, emptyItem);
      } else {
        this.hourRules.splice(i, 0, emptyItem);
      }
    },
    deleteRule(item, i) {
      this.hourRules.splice(i, 1);
    },
    checkArray() {
      const setDurations = new Set();
      for (let index = 0; index < this.hourRules.length; index++) {
        const item = this.hourRules[index];
        const realIndex = index + 1;
        if (setDurations.has(item.duration)) {
          this.$message.warning(`第${realIndex}条时长规则重复，请检查`);
          return false;
        }
        setDurations.add(item.duration);
        if (item.credit === 0 || item.credit === "") {
          this.$message.warning(`第${realIndex}条的可获得学时需大于0`);
          return false;
        }
      }
      return true;
    },
  },
  created() {
    const _this = this;
    _this.getSysParamByTypes(["CREDIT_RESOURCE_TYPE"]);
    topDeptList().then(res => {
      if (!res || res.code !== 0) return;
      this.deptList = res.data;
    });

  },
  beforeDestroy() {
  }
};
</script>

<style scoped lang="scss">
.rules_row {
  margin-bottom: 12px;

  .time {
    width: 120px;
  }


  .credit {
    width: 120px;
  }

  .add-m {
    margin-left: 16px;
    margin-right: 12px;
  }
}
</style>
